const url = getUrl()

function getUrl() {
    if (window.location.hostname === 'localhost') {
        return 'http://127.0.0.1:8000/api/wrkt/'
    }
    if (window.location.hostname.startsWith('127')) {
        return 'http://localhost:8000/api/wrkt/'
    }
    if (window.location.hostname.startsWith('192')) {
        return 'http://' + window.location.hostname + ':8000/api/wrkt/'
    }
    return 'https://wrkt.procrastinationlog.com/api/wrkt/'
}


export function makeRequest(endpoint, options = {}, noLog) {
    const headers = {
        'Auth': localStorage.getItem('wrkt-token'),
        'User': localStorage.getItem('wrkt-user'),
    }
    if (options.contentType === false) {
        // skip
    }
    else if (typeof(options.contentType) === 'string') {
        headers['Content-Type'] = options.contentType
    }
    else {
        headers['Content-Type'] = 'application/json'
    }

    delete options.contentType

    return fetch(url + endpoint, {
        method: 'POST',
        ...options,
        headers,
    }).then(response => {
        if (response.error) {
            throw response.error
        }
        try {
            return response.json()
        }
        catch (error) {
            console.error('response.json()', error)
            throw error
        }
    })
    .then(data => {
        if (data.error) {
            console.warn('data.error', data.error)
            throw data.error
        }
        return data
    })
    .catch(error => {
        throw error
    })
}
